module.exports = "/assets/data/5af0887303ecdb4688a9c7d2c879e33d-DN19.data.json";